/**
 * Get Mixpanel's `distinct_id` property, if it exists.
 *
 * This lives outside `mixpanel/base.ts` so other modules can read the device id
 * without importing the heavier Mixpanel implementation module.
 */
export function getMixpanelDistinctID(): string | undefined {
  if (window.mixpanel && window.mixpanel.get_distinct_id) {
    return window.mixpanel.get_distinct_id()
  }
}
